import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Modal from 'components/Modal';
import Button from 'components/Button';
import { modalWidths, zIndexValues } from 'utils/styles';
import intl from 'react-intl-universal';
import logger from 'utils/logger';
import PropTypes from 'prop-types';

const log = logger.createLogger('ConfirmDeleteModal');

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  isKeyImageFromViewer: PropTypes.bool.isRequired,
  handleRemoveKeyImage: PropTypes.func.isRequired,
  handleRemoveKeyImageFromIssue: PropTypes.func.isRequired,
  keyImage: PropTypes.object,
};

const ConfirmDeleteModal = ({
  isOpen,
  setOpen,
  isKeyImageFromViewer,
  handleRemoveKeyImage,
  handleRemoveKeyImageFromIssue,
  keyImage,
}) => {
  const handleDelete = () => {
    handleRemoveKeyImage();
  };

  const handleCompleteRemove = () => {
    handleRemoveKeyImageFromIssue();
  };

  return (
    <Modal
      isOpen={isOpen}
      testid="modal:confirm"
      onClose={() => setOpen(false)}
      minWidth={modalWidths.xs}
      sx={{
        backgroundColor: 'white',
        borderRadius: '10px',
      }}
      withCloseIcon={false}
      renderLink={() => {}}
      zIndex={zIndexValues.modal5}
      renderContent={(modal) => (
        <div style={{ padding: 20 }}>
          <Typography variant="h3">
            {intl.get('issue_details_report_preview_text_delete_key_image')}
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{ marginTop: 2, marginBottom: 2 }}>
            {intl.get(
              'issue_details_report_preview_text_delete_key_image_body',
              {
                keyImage: keyImage.fileName,
              }
            )}
          </Typography>
          <Typography variant="body2" sx={{ marginTop: 2, marginBottom: 2 }}>
            {intl.get('issue_details_report_preview_text_warning_message')}
          </Typography>
          <Grid container spacing={2} sx={{ justifyContent: 'center' }}>
            <Button variant="primary" onClick={() => handleDelete(modal)}>
              {intl.get(
                'issue_details_report_preview_text_remove_from_current_report'
              )}
            </Button>
            {isKeyImageFromViewer && (
              <Button
                variant="secondary"
                onClick={() => handleCompleteRemove(modal)}>
                {intl.get(
                  'issue_details_report_preview_text_remove_from_issue'
                )}
              </Button>
            )}
            <Button variant="danger" onClick={() => modal.close()}>
              {intl.get('issue_details_report_preview_text_cancel')}
            </Button>
          </Grid>
        </div>
      )}
    />
  );
};

ConfirmDeleteModal.propTypes = propTypes;
export default ConfirmDeleteModal;
